<script setup lang="ts">
  defineProps<{
    type?:
      | 'primary'
      | 'success'
      | 'danger'
      | 'gray'
      | 'secondary'
      | 'primary-outline'
      | 'gray-outline',
  }>()
</script>

<template>
  <span
    :class="[
      'badge',
      {
        'badge-primary': type === 'primary',
        'badge-success': type === 'success',
        'badge-danger': type === 'danger',
        'badge-secondary': type === 'secondary',
        'badge-gray': type === 'gray',
        'badge-primary-outline': type === 'primary-outline',
        'badge-gray-outline': type === 'gray-outline',
      },
    ]">
    <slot></slot>
  </span>
</template>

<style lang="postcss" scoped>
  .badge {
    @apply inline-block rounded border px-2 py-1 text-xs;
  }
  .badge-primary {
    @apply border-primary-600 bg-primary-600 text-white;
  }
  .badge-primary-outline {
    @apply border-primary-600 text-primary-600;
  }
  .badge-success {
    @apply border-success-600 bg-success-600 text-white;
  }
  .badge-danger {
    @apply border-red-600 bg-red-600 text-white;
  }
  .badge-gray {
    /* @apply border-gray-600 bg-gray-600 text-white; */
    @apply border-gray-200 bg-gray-200;
  }
  .badge-gray-outline {
    @apply border-gray-600 text-gray-600;
  }
  .badge-secondary {
    @apply border-blue-600 bg-blue-600 text-white;
  }
</style>
